<template>
  <div class="about-page">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="nav-container">
        <div class="logo">
          <i class="fas fa-home" @click="goBack"></i>
          <span>凯尚设计</span>
        </div>
        <!-- <div class="nav-menu" @click="toggleMenu">
          <i class="fas fa-bars"></i>
        </div> -->
      </div>
      
      <!-- 导航菜单 -->
      <transition name="slide">
        <div class="fullscreen-menu" v-show="menuVisible">
          <div class="menu-header">
            <div class="logo">
              <i class="fas fa-home"></i>
              <span>凯尚设计</span>
            </div>
            <div class="close-btn" @click="toggleMenu">
              <i class="fas fa-times"></i>
            </div>
          </div>
          <nav class="menu-links">
            <a href="#" class="menu-link"><i class="fas fa-home"></i>首页</a>
            <a href="#" class="menu-link"><i class="fas fa-pencil-ruler"></i>设计案例</a>
            <a href="#" class="menu-link active"><i class="fas fa-building"></i>关于我们</a>
            <a href="#" class="menu-link"><i class="fas fa-newspaper"></i>设计资讯</a>
            <a href="#" class="menu-link"><i class="fas fa-phone-alt"></i>联系我们</a>
          </nav>
          <div class="social-links">
            <a href="#"><i class="fab fa-weixin"></i></a>
            <a href="#"><i class="fab fa-weibo"></i></a>
            <a href="#"><i class="fab fa-instagram"></i></a>
            <a href="#"><i class="fab fa-pinterest"></i></a>
          </div>
        </div>
      </transition>
      
      <!-- 头部内容 -->
      <div class="header-content">
        <h1>关于凯尚设计</h1>
        <p>打造梦想居所，诠释优雅生活</p>
        <div class="scroll-indicator">
          <span></span>
        </div>
      </div>
      <div class="header-overlay"></div>
    </header>
    
    <!-- 主要内容区域 -->
    <main class="content">
      <!-- 公司简介 -->
      <section class="section fade-in">
        <div class="section-title">
          <div class="icon-circle">
            <i class="fas fa-building"></i>
          </div>
          <h2>公司简介</h2>
        </div>
        <div class="intro-text">
          <p>凯尚设计创立于2015年，专注于高端别墅设计与定制服务。我们拥有一支国际化的设计团队，致力于将艺术美学与实用功能完美融合。</p>
          <p>秉持"设计改变生活"的理念，我们已为超过500个家庭打造了梦想居所，项目遍布全国20多个省市。</p>
        </div>
        <div class="stats">
          <div class="stat-item">
            <div class="stat-icon">
              <i class="fas fa-history"></i>
            </div>
            <div class="stat-number">10+年</div>
            <div class="stat-label">行业经验</div>
          </div>
          <div class="stat-item">
            <div class="stat-icon">
              <i class="fas fa-home"></i>
            </div>
            <div class="stat-number">500+</div>
            <div class="stat-label">成功项目</div>
          </div>
          <div class="stat-item">
            <div class="stat-icon">
              <i class="fas fa-smile"></i>
            </div>
            <div class="stat-number">99%</div>
            <div class="stat-label">客户满意度</div>
          </div>
        </div>
      </section>
      
      <!-- 设计理念 -->
      <section class="section fade-in delay-1">
        <div class="section-title">
          <div class="icon-circle">
            <i class="fas fa-lightbulb"></i>
          </div>
          <h2>设计理念</h2>
        </div>
        <div class="philosophy">
          <div class="philosophy-item">
            <div class="philosophy-icon">
              <i class="fas fa-palette"></i>
            </div>
            <h3>艺术美学</h3>
            <p>将艺术融入生活空间，创造视觉与情感的双重享受</p>
          </div>
          <div class="philosophy-item">
            <div class="philosophy-icon">
              <i class="fas fa-hands-helping"></i>
            </div>
            <h3>功能实用</h3>
            <p>以人为本的设计，满足现代生活的多样化需求</p>
          </div>
          <div class="philosophy-item">
            <div class="philosophy-icon">
              <i class="fas fa-leaf"></i>
            </div>
            <h3>自然融合</h3>
            <p>将自然元素引入室内，创造健康舒适的生活环境</p>
          </div>
        </div>
      </section>
      
      <!-- 核心团队 -->
      <!-- <section class="section fade-in delay-2">
        <div class="section-title">
          <div class="icon-circle">
            <i class="fas fa-users"></i>
          </div>
          <h2>核心团队</h2>
        </div>
        <div class="team-slider">
          <div class="team-members">
            <div v-for="(member, index) in teamMembers" :key="index" class="team-member">
              <div class="member-avatar" :style="{ background: member.color }">
                <i :class="member.icon"></i>
              </div>
              <div class="member-info">
                <div class="member-name">{{ member.name }}</div>
                <div class="member-role">{{ member.role }}</div>
                <div class="member-bio">{{ member.bio }}</div>
              </div>
            </div>
          </div>
          <div class="slider-indicators">
            <span v-for="(member, index) in teamMembers" :key="index" 
                  :class="{ active: currentMember === index }"
                  @click="currentMember = index"></span>
          </div>
        </div>
      </section> -->
      
      <!-- 荣誉奖项 -->
      <!-- <section class="section fade-in delay-3">
        <div class="section-title">
          <div class="icon-circle">
            <i class="fas fa-award"></i>
          </div>
          <h2>荣誉奖项</h2>
        </div>
        <div class="awards">
          <div class="award-item">
            <div class="award-icon">
              <i class="fas fa-trophy"></i>
            </div>
            <div class="award-content">
              <h3>2023年度最佳别墅设计</h3>
              <p>中国室内设计协会</p>
            </div>
          </div>
          <div class="award-item">
            <div class="award-icon">
              <i class="fas fa-medal"></i>
            </div>
            <div class="award-content">
              <h3>创新设计金奖</h3>
              <p>亚太空间设计大奖赛</p>
            </div>
          </div>
          <div class="award-item">
            <div class="award-icon">
              <i class="fas fa-star"></i>
            </div>
            <div class="award-content">
              <h3>十佳设计工作室</h3>
              <p>《家居世界》杂志评选</p>
            </div>
          </div>
        </div>
      </section> -->
      
      <!-- 服务流程 -->
      <!-- <section class="section fade-in delay-4">
        <div class="section-title">
          <div class="icon-circle">
            <i class="fas fa-list-ol"></i>
          </div>
          <h2>服务流程</h2>
        </div>
        <div class="process">
          <div class="process-item">
            <div class="process-number">1</div>
            <div class="process-content">
              <h3>需求沟通</h3>
              <p>深入了解客户需求与生活习惯</p>
            </div>
          </div>
          <div class="process-item">
            <div class="process-number">2</div>
            <div class="process-content">
              <h3>概念设计</h3>
              <p>提供初步设计方案与风格方向</p>
            </div>
          </div>
          <div class="process-item">
            <div class="process-number">3</div>
            <div class="process-content">
              <h3>方案深化</h3>
              <p>详细设计、材料选择与预算规划</p>
            </div>
          </div>
          <div class="process-item">
            <div class="process-number">4</div>
            <div class="process-content">
              <h3>施工执行</h3>
              <p>全程监理确保设计完美呈现</p>
            </div>
          </div>
        </div>
      </section> -->
      
      <!-- 联系方式 -->
      <section class="section fade-in delay-5">
        <div class="section-title">
          <div class="icon-circle">
            <i class="fas fa-envelope"></i>
          </div>
          <h2>联系我们</h2>
        </div>
        <div class="contact-methods">
          <div v-for="(contact, index) in contacts" :key="index" class="contact-item">
            <div class="contact-icon" :style="{ background: contact.color }">
              <i :class="contact.icon"></i>
            </div>
            <div class="contact-info">
              <div class="contact-label">{{ contact.label }}</div>
              <div class="contact-value">{{ contact.value }}</div>
            </div>
          </div>
        </div>
        <!-- <div class="contact-form">
          <h3>预约咨询</h3>
          <input type="text" placeholder="您的姓名">
          <input type="tel" placeholder="联系电话">
          <textarea placeholder="咨询内容"></textarea>
          <button class="submit-btn">提交预约</button>
        </div> -->
      </section>
    </main>
    
    <!-- 底部区域 -->
    <footer class="fade-in delay-6">
      <div class="footer-content">
        <div class="footer-logo">
          <i class="fas fa-home"></i>
          <span>凯尚设计</span>
        </div>
        <p>打造梦想居所，诠释优雅生活</p>
        <div class="social-icons">
          <a href="#" class="social-icon"><i class="fab fa-weixin"></i></a>
          <a href="#" class="social-icon"><i class="fab fa-weibo"></i></a>
          <a href="#" class="social-icon"><i class="fab fa-instagram"></i></a>
          <a href="#" class="social-icon"><i class="fab fa-pinterest"></i></a>
        </div>
        <div class="footer-links">
          <a href="#">关于我们</a>
          <a href="#">设计案例</a>
          <a href="#">服务流程</a>
          <a href="#">隐私政策</a>
        </div>
      </div>
      <div class="copyright">
        <p>© 2025 凯尚设计 版权所有</p>
        <!-- <p>沪ICP备12345678号</p> -->
      </div>
      
      <!-- 返回顶部按钮 -->
      <div class="back-to-top" :class="{ show: showBackToTop }" @click="scrollToTop">
        <i class="fas fa-arrow-up"></i>
      </div>
    </footer>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  setup() {
    const menuVisible = ref(false);
    const currentMember = ref(0);
    const showBackToTop = ref(false);
    
    // 团队成员
    const teamMembers = ref([
      { 
        name: '张逸明', 
        role: '首席设计师', 
        bio: '15年设计经验，米兰理工大学硕士，擅长现代简约与新中式风格',
        icon: 'fas fa-pencil-ruler',
        color: '#8C6A5D'
      },
      { 
        name: '李婉婷', 
        role: '软装总监', 
        bio: '10年软装设计经验，精通色彩搭配与空间艺术陈设',
        icon: 'fas fa-couch',
        color: '#B99B8B'
      },
      { 
        name: '王振宇', 
        role: '工程总监', 
        bio: '12年施工管理经验，对工艺细节有极致追求',
        icon: 'fas fa-tools',
        color: '#A67C52'
      },
      { 
        name: '陈思涵', 
        role: '客户经理', 
        bio: '8年客户服务经验，善于理解客户需求并提供专业建议',
        icon: 'fas fa-user-tie',
        color: '#D9C6B0'
      }
    ]);
    
    // 联系方式
    const contacts = ref([
    //   { 
    //     icon: 'fas fa-map-marker-alt', 
    //     label: '地址', 
    //     value: '上海市浦东新区创意设计中心A座18层',
    //     color: '#8C6A5D'
    //   },
      { 
        icon: 'fas fa-phone', 
        label: '微信', 
        value: 'm418257058',
        color: '#B99B8B'
      },
      { 
        icon: 'fas fa-envelope', 
        label: '邮箱', 
        value: '418257058@qq.com',
        color: '#A67C52'
      },
      { 
        icon: 'fas fa-clock', 
        label: '工作时间', 
        value: '周一至周六 9:00-18:00',
        color: '#D9C6B0'
      }
    ]);
    
    // 切换菜单显示状态
    const toggleMenu = () => {
      menuVisible.value = !menuVisible.value;
    };

    const goBack = () => {
      window.history.back();
    };
    
    // 滚动到顶部
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    
    // 监听滚动事件
    const handleScroll = () => {
      showBackToTop.value = window.scrollY > 300;
    };
    
    // 添加滚动监听
    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
    });
    
    // 移除滚动监听
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });
    
    return {
      menuVisible,
      currentMember,
      showBackToTop,
      teamMembers,
      contacts,
      toggleMenu,
      scrollToTop,
      goBack
    };
  }
}
</script>

<style scoped>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

:root {
  --primary: #8C6A5D;
  --primary-light: #B99B8B;
  --secondary: #D9C6B0;
  --accent: #A67C52;
  --light: #F8F5F0;
  --dark: #3A2E26;
  --text: #4A4039;
  --text-light: #7A6E66;
  --shadow: rgba(58, 46, 38, 0.1);
  --transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.1);
}

.about-page {
  font-family: 'Noto Sans SC', sans-serif;
  background-color: var(--light);
  color: var(--text);
  line-height: 1.6;
  max-width: 480px;
  margin: 0 auto;
  overflow-x: hidden;
  position: relative;
  box-shadow: 0 0 30px var(--shadow);
  min-height: 100vh;
}

/* 头部样式 */
.header {
  position: relative;
  height: 100vh;
  min-height: 600px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--primary), var(--accent));
  z-index: 1;
}

.header-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 2;
}

.nav-container {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.logo {
  font-weight: 700;
  font-size: 1.4rem;
  color: white;
  display: flex;
  align-items: center;
  z-index: 10;
}

.logo i {
  margin-right: 8px;
  font-size: 1.2rem;
}

.nav-menu {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  cursor: pointer;
  z-index: 10;
  transition: var(--transition);
}

.nav-menu:hover {
  background: rgba(255, 255, 255, 0.3);
}

.header-content {
  position: relative;
  z-index: 3;
  text-align: center;
  padding: 0 20px;
  color: white;
  margin-top: auto;
  margin-bottom: 80px;
}

.header-content h1 {
  font-family: 'Noto Serif SC', serif;
  font-size: 2.8rem;
  font-weight: 700;
  margin-bottom: 15px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

.header-content p {
  font-size: 1.2rem;
  max-width: 320px;
  margin: 0 auto 30px;
  opacity: 0.9;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.scroll-indicator {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.scroll-indicator span {
  display: block;
  width: 24px;
  height: 40px;
  border: 2px solid white;
  border-radius: 12px;
  position: relative;
}

.scroll-indicator span::after {
  content: '';
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 8px;
  background: white;
  border-radius: 2px;
  animation: scroll 1.5s infinite;
}

@keyframes scroll {
  0% { top: 6px; opacity: 1; }
  100% { top: 20px; opacity: 0; }
}

/* 全屏菜单样式 */
.fullscreen-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 100;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.menu-header .logo {
  color: var(--primary);
  font-size: 1.6rem;
}

.close-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--light);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary);
  font-size: 1.4rem;
  cursor: pointer;
}

.menu-links {
  display: flex;
  flex-direction: column;
  margin: 30px 0;
  flex-grow: 1;
}

.menu-link {
  display: flex;
  align-items: center;
  padding: 18px 0;
  font-size: 1.2rem;
  color: var(--text);
  text-decoration: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: var(--transition);
}

.menu-link i {
  margin-right: 15px;
  width: 24px;
  text-align: center;
  color: var(--primary);
}

.menu-link.active {
  color: var(--primary);
  font-weight: 600;
}

.menu-link:hover {
  color: var(--primary);
  padding-left: 10px;
}

.social-links {
  display: flex;
  justify-content: center;
  gap: 25px;
  padding: 20px 0;
}

.social-links a {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--light);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  transition: var(--transition);
}

.social-links a:hover {
  background: var(--primary);
  color: white;
  transform: translateY(-5px);
}

/* 菜单动画 */
.slide-enter-active, .slide-leave-active {
  transition: transform 0.5s ease, opacity 0.4s ease;
}

.slide-enter-from, .slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

/* 主要内容样式 */
.content {
  padding: 0 20px 30px;
}

.section {
  background: white;
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: var(--transition);
  position: relative;
  overflow: hidden;
}

.section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  background: linear-gradient(to bottom, var(--primary), var(--accent));
}

.section:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.icon-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--light);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 1.4rem;
}

.section-title h2 {
  font-family: 'Noto Serif SC', serif;
  font-weight: 600;
  color: var(--dark);
  font-size: 1.6rem;
}

/* 公司简介 */
.intro-text {
  margin-bottom: 25px;
  font-size: 1.05rem;
  color: var(--text);
  line-height: 1.8;
}

.stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-top: 20px;
}

.stat-item {
  background: var(--light);
  border-radius: 15px;
  padding: 20px 10px;
  text-align: center;
  transition: var(--transition);
}

.stat-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(140, 106, 93, 0.1);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  font-size: 1.2rem;
}

.stat-number {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--primary);
  margin-bottom: 5px;
}

.stat-label {
  font-size: 0.9rem;
  color: var(--text-light);
}

/* 设计理念 */
.philosophy {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
  margin-top: 15px;
}

.philosophy-item {
  text-align: center;
  padding: 20px 15px;
  background: var(--light);
  border-radius: 15px;
  transition: var(--transition);
}

.philosophy-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.philosophy-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(140, 106, 93, 0.1);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  font-size: 1.4rem;
}

.philosophy-item h3 {
  font-size: 1.1rem;
  margin-bottom: 10px;
  color: var(--dark);
}

.philosophy-item p {
  font-size: 0.9rem;
  color: var(--text-light);
}

/* 核心团队 */
.team-slider {
  position: relative;
  margin-top: 20px;
}

.team-members {
  overflow: hidden;
  border-radius: 20px;
}

.team-member {
  display: flex;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.member-avatar {
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2.5rem;
}

.member-info {
  padding: 25px;
  flex-grow: 1;
}

.member-name {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 5px;
  color: var(--dark);
}

.member-role {
  font-size: 1rem;
  color: var(--primary);
  margin-bottom: 15px;
  font-weight: 500;
}

.member-bio {
  font-size: 0.95rem;
  color: var(--text-light);
  line-height: 1.6;
}

.slider-indicators {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
}

.slider-indicators span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--secondary);
  cursor: pointer;
  transition: var(--transition);
}

.slider-indicators span.active {
  background: var(--primary);
  transform: scale(1.2);
}

/* 荣誉奖项 */
.awards {
  margin-top: 20px;
}

.award-item {
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px dashed var(--secondary);
}

.award-item:last-child {
  border-bottom: none;
}

.award-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--light);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  font-size: 1.4rem;
  flex-shrink: 0;
}

.award-content h3 {
  font-size: 1.1rem;
  margin-bottom: 5px;
  color: var(--dark);
}

.award-content p {
  font-size: 0.95rem;
  color: var(--text-light);
}

/* 服务流程 */
.process {
  margin-top: 20px;
}

.process-item {
  display: flex;
  padding: 20px 0;
  position: relative;
}

.process-item::before {
  content: '';
  position: absolute;
  left: 25px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: var(--secondary);
  z-index: 1;
}

.process-item:last-child::before {
  display: none;
}

.process-number {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--light);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  font-weight: 700;
  font-size: 1.2rem;
  z-index: 2;
  flex-shrink: 0;
}

.process-content h3 {
  font-size: 1.1rem;
  margin-bottom: 8px;
  color: var(--dark);
}

.process-content p {
  font-size: 0.95rem;
  color: var(--text-light);
}

/* 联系方式 */
.contact-methods {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 30px;
}

.contact-item {
  display: flex;
  align-items: center;
  background: var(--light);
  border-radius: 15px;
  padding: 15px;
  transition: var(--transition);
}

.contact-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.contact-icon {
  width: 50px;
  height: 50px;
  border-radius: 15px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.contact-label {
  font-size: 0.9rem;
  color: var(--text-light);
  margin-bottom: 3px;
}

.contact-value {
  font-weight: 500;
  color: var(--dark);
  font-size: 1rem;
}

.contact-form {
  background: var(--light);
  border-radius: 20px;
  padding: 25px;
}

.contact-form h3 {
  text-align: center;
  margin-bottom: 20px;
  color: var(--dark);
  font-size: 1.3rem;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 15px;
  margin-bottom: 15px;
  border: none;
  border-radius: 12px;
  background: white;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 1rem;
}

.contact-form textarea {
  height: 120px;
  resize: none;
}

.submit-btn {
  width: 100%;
  padding: 16px;
  background: linear-gradient(to right, var(--primary), var(--accent));
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.submit-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(140, 106, 93, 0.4);
}

/* 页脚样式 */
footer {
  background: var(--dark);
  color: var(--light);
  padding: 40px 20px 20px;
  position: relative;
}

.footer-content {
  max-width: 400px;
  margin: 0 auto;
  text-align: center;
}

.footer-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 700;
  color: white;
  margin-bottom: 15px;
}

.footer-logo i {
  margin-right: 10px;
  color: var(--secondary);
}

footer p {
  margin-bottom: 20px;
  opacity: 0.8;
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 25px 0;
}

.social-icon {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: var(--transition);
}

.social-icon:hover {
  background: var(--primary);
  transform: translateY(-5px);
}

.footer-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin: 30px 0;
}

.footer-links a {
  color: var(--light);
  text-decoration: none;
  opacity: 0.8;
  transition: var(--transition);
}

.footer-links a:hover {
  opacity: 1;
  color: var(--secondary);
}

.copyright {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  font-size: 0.85rem;
  opacity: 0.6;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  cursor: pointer;
  opacity: 0;
  transform: translateY(20px);
  transition: var(--transition);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  z-index: 50;
}

.back-to-top.show {
  opacity: 1;
  transform: translateY(0);
}

.back-to-top:hover {
  background: var(--accent);
  transform: translateY(-5px);
}

/* 动画效果 */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

.fade-in {
  animation: fadeIn 0.8s ease forwards;
  opacity: 0;
}

.delay-1 { animation-delay: 0.1s; }
.delay-2 { animation-delay: 0.2s; }
.delay-3 { animation-delay: 0.3s; }
.delay-4 { animation-delay: 0.4s; }
.delay-5 { animation-delay: 0.5s; }
.delay-6 { animation-delay: 0.6s; }

/* 响应式调整 */
@media (max-width: 400px) {
  .header-content h1 {
    font-size: 2.2rem;
  }
  
  .header-content p {
    font-size: 1rem;
  }
  
  .section {
    padding: 25px 20px;
  }
  
  .stats {
    grid-template-columns: 1fr;
  }
  
  .team-member {
    flex-direction: column;
  }
  
  .member-avatar {
    width: 100%;
    height: 200px;
  }
}
</style>